import React, { FC, Fragment } from "react";
import { Icon } from "../icon";
import { Button } from "../../modules";

export interface IConfirmDeletePopupProps {
  onConfirm: (code: string) => void;
  onClose: () => void;
}

export const ConfirmDeletePopup: FC<IConfirmDeletePopupProps> = ({ onClose, onConfirm }) => {
  return (
    <Fragment>
      {(() => {
          const id = `popup-confirm-delete`;
          return (
            <div
              className="confirm-delete-popup"
              id={id}
            >
              <div className="box">
                <div className="head">
                  Xác nhận xóa
                  <div className="btnClose" onClick={onClose} >
                    <Icon.Close />
                  </div>
                </div>
                <div className="content">
                  <p>Bạn chắc chắn muốn xóa dữ liệu này?</p>
                  <Button
                    label="Xác nhận"
                    buttonType="warning"
                    onClick={onConfirm}
                  />
                </div>
              </div>
            </div>
          );
        
      })()}
    </Fragment>
  );
};
